import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './screens/Home';
import About from './screens/About';
import Prompt from './screens/Prompt';
import Pricing from './screens/Pricing';
import Login from './screens/Login';
import Signup from './screens/Signup';
import Profile from './screens/Profile';
import Payment from './screens/Payment';
import NotFound from './screens/NotFound';
import AuthProvider, { useAuth } from './utilities/AuthContext';

function PrivateRoute({ element }) {
  let { currentUser } = useAuth();
  // console.log(currentUser);
  return !currentUser ? (
    <Navigate to="/login" replace />
  ) : (
    element
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/prompt" element={<Prompt />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/profile" element={<Profile />} />
          <Route
            path="/payment"
            element={<PrivateRoute element={<Payment />} />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
